var components
try {
  components = {
    uPopup: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-popup/u-popup" */ "uview-ui/components/u-popup/u-popup.vue"
      )
    },
    uModal: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-modal/u-modal" */ "uview-ui/components/u-modal/u-modal.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = (_vm.info.deposit / 100).toFixed(2)
  var g1 = _vm.info.memberRidesResponse
    ? _vm.info.memberRidesResponse.rideStartTime.substring(10, 16)
    : null
  var g2 = _vm.info.memberRidesResponse
    ? (_vm.info.memberRidesResponse.rideTime / 60).toFixed(1)
    : null
  var g3 = _vm.info.memberRidesResponse
    ? (_vm.info.memberRidesResponse.baseTime / 60).toFixed(1)
    : null
  var g4 = _vm.info.memberRidesResponse
    ? (_vm.info.memberRidesResponse.basePrice / 100).toFixed(2)
    : null
  var g5 = _vm.info.memberRidesResponse
    ? (_vm.info.memberRidesResponse.unitPrice / 100).toFixed(2)
    : null
  var g6 = _vm.info.memberRidesResponse
    ? _vm.info.memberRidesResponse.rideStartTime.substring(5, 16)
    : null
  var g7 = _vm.info.memberRidesResponse
    ? _vm.info.memberRidesResponse.rideEndTime.substring(11, 16)
    : null
  var g8 = _vm.info.memberRidesResponse
    ? (_vm.info.memberRidesResponse.baseTime / 60).toFixed(1)
    : null
  var g9 = _vm.info.memberRidesResponse
    ? (_vm.info.memberRidesResponse.basePrice / 100).toFixed(2)
    : null
  var g10 = _vm.info.memberRidesResponse
    ? (_vm.info.memberRidesResponse.unitPrice / 100).toFixed(2)
    : null
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.show = false
    }
    _vm.e1 = function ($event) {
      _vm.show = false
    }
    _vm.e2 = function ($event) {
      _vm.show1 = false
    }
    _vm.e3 = function ($event) {
      _vm.active = !_vm.active
    }
    _vm.e4 = function ($event) {
      _vm.show1 = false
    }
    _vm.e5 = function ($event) {
      _vm.show1 = false
    }
    _vm.e6 = function ($event) {
      _vm.show2 = false
    }
    _vm.e7 = function ($event) {
      _vm.show6 = false
    }
    _vm.e8 = function ($event) {
      _vm.show3 = false
    }
    _vm.e9 = function ($event) {
      _vm.show4 = false
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        g1: g1,
        g2: g2,
        g3: g3,
        g4: g4,
        g5: g5,
        g6: g6,
        g7: g7,
        g8: g8,
        g9: g9,
        g10: g10,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }